import React from "react";
import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
  // Placeholder number
  const number = "971501234567";
  const text = encodeURIComponent("Hello, I'd like to enquire about off-plan properties.");
  const href = `https://wa.me/${number}?text=${text}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-floating-btn"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 end-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#C9A84C]/30 animate-ping" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#1E2235] border border-[#C9A84C] text-[#C9A84C] group-hover:bg-[#C9A84C] group-hover:text-[#0A0E1A] transition-all duration-500 shadow-[0_0_30px_rgba(201,168,76,0.25)]">
        <MessageCircle className="w-6 h-6" />
      </span>
    </a>
  );
};

export default WhatsAppButton;